<template>
    <div>
        <live-klass-filter-link :filterLayout="filterLayout" :filterData="filterSet.filter"
                               :paginationData="filterSet.page"></live-klass-filter-link>
        <live-klass-list-link :listLayout="listLayout" :paginationData="filterSet.page" :liveklassData="List"></live-klass-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"
                         :listLength="List.length" :type="liveklassType"
                         :filterData="filterSet.filter"></pagination-link>
    </div>
</template>

<script>
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import alertMixins from "@/mixins/alertMixins";
import liveklassUtil from "@/components/liveklass/liveklassUtil";
import LiveKlassListLink from "@/components/liveklass/LiveKlassListLink";
import LiveKlassFilterLink from "@/components/liveklass/LiveKlassFilterLink";
import PaginationLink from "@/components/liveklass/PaginationLink";
import util from "@/mixins/util";

const {filterConfig} = liveklassUtil;

export default {
    name: "LiveKlassAdjustListComponent",
    mixins: [filterMixins, listMixins, alertMixins, liveklassUtil],
    components: {LiveKlassListLink, LiveKlassFilterLink, PaginationLink},
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
            setSort: this.setSort,
            liveklassListSetData: this.setData,
            updateAdjustStatus: this.runAdjust,
        }
    },
    inject: ['changeLoading'],
    props: {
        liveklassType: {default: ''},
        liveKlassKey: {default: ''},
    },
    data() {
        return {
            listLayout: '',
            filterLayout: '',
            paginationLayout: '',

            getFunc: '',
            listApiParamSet: {},
            pageRow: 10,

            keyName: '',
            adjustList: [],
            selectArr: [],
            /*필터 classname*/
        }
    },
    created() {
        this.setFilterConfig(filterConfig)
        this.setParserType('url', this.$route.fullPath);
        this.initConfig();
    },
    mounted() {
        this.getList(true);
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initConfig() {
            let config = this.returnLiveKlassConfig(this.liveklassType)
            this.listLayout = config.listLayout;
            this.filterLayout = config.filterLayout;
            this.paginationLayout = config.paginationLayout;
            this.getFunc = config.getFunc;
            this.listApiParamSet = config.listApiParamSet;
            this.filterSort = config.filterSort;

            if(!util.isEmpty(this.liveKlassKey)){
                this.listApiParamSet.sid = this.liveKlassKey;
            }

            let listOptions = {
                url: this.$api.$liveklass[this.getFunc],
                defaultParams: this.listApiParamSet
            }
            this.initList('api', listOptions);

            this.keyName = config.keyName;
        },
        runAdjust(status) {
            if (util.isEmpty(this.selectArr)) {
                this.errorAlert('정산 상태를 수정할 항목을 선택해주세요.');
                return false;
            } else {
                this.createConfirm({
                    content: '정말 정산 상태를 수정하시겠습니까?',
                    confirm: () => {
                        this.changeLoading(true)
                        this.updateAdjust(status);
                    }
                })

            }
        },
        updateAdjust(status) {
            let params = {
                'ps_idx': this.selectArr,
                'status': status,
            };

            try {
                this.$api.$liveklass.updateAdjust(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type != 1) {
                        this.changeLoading(false);
                        this.errorAlert('정산 상태 수정에 실패했습니다.');
                        return false;
                    } else {
                        this.getList(true);
                        this.changeLoading(false);
                        this.errorAlert('정산 상태를 수정하였습니다.');
                        return false;
                    }
                });
            } catch (e) {
                this.changeLoading(false);
                this.errorAlert('정산 상태 수정에 실패했습니다.');
                console.log(e);
            }
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
